import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui';
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.css'
import './assets/iconfont/iconfont.css'
  // import Blob from './vendor/Blob'//导出excel
  // import Export2Excel from './vendor/Export2Excel.js'//导出excel

Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.$bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
